// Sidebar menu icons
import "../../images/icons/menu-icons/products-menu.svg";
import "../../images/icons/menu-icons/customers-menu.svg";
import "../../images/icons/menu-icons/suppliers-menu.svg";
import "../../images/icons/menu-icons/sales-menu.svg";
import "../../images/icons/menu-icons/purchases-menu.svg";
import "../../images/icons/menu-icons/deliveries-menu.svg";
import "../../images/icons/menu-icons/returns-menu.svg";
import "../../images/icons/menu-icons/settings-menu.svg";
import "../../images/icons/menu-icons/plus-rounded.svg";
import "../../images/icons/menu-icons/cog-outline.svg";
import "../../images/icons/menu-icons/toolbox-outline.svg";
import "../../images/icons/menu-icons/filter-outline.svg";
import "../../images/icons/menu-icons/file-chart-outline.svg";
import "../../images/icons/menu-icons/bell-outline.svg";
import "../../images/icons/menu-icons/menu-calling.svg";
import "../../images/icons/menu-icons/application-outline.svg";
import "../../images/icons/menu-icons/messaging-menu.svg";
import "../../images/icons/menu-icons/credit-notes.svg";
import "../../images/icons/menu-icons/warranty-claim.svg";
import "../../images/icons/menu-icons/surveys-menu.svg";


// General icons
import "../../images/icons/logic-cloud-logo.svg";
import "../../images/icons/ukem-energy-logo.svg";
import "../../images/icons/arrow.svg";
import "../../images/icons/chevron.svg";
import "../../images/icons/check.svg";
import "../../images/icons/clipboard-check.svg";
import "../../images/icons/close.svg";
import "../../images/icons/map-pin.svg";
import "../../images/icons/new-user.svg";
import "../../images/icons/search.svg";
import "../../images/icons/calendar.svg";
import "../../images/icons/list-view.svg";
import "../../images/icons/clock.svg";
import "../../images/icons/more-vertical.svg";
import "../../images/icons/merge.svg";
import "../../images/icons/merge-individual.svg";
import "../../images/icons/chat.svg";
import "../../images/icons/alert-circle.svg";
import "../../images/icons/account-balance.svg";
import "../../images/icons/cellphone.svg";
import "../../images/icons/mail.svg";
import "../../images/icons/refresh.svg";
import "../../images/icons/bar-chart.svg";
import "../../images/icons/info.svg";
import "../../images/icons/calling-dialpad.svg";
import "../../images/icons/circle-check.svg";
import "../../images/icons/circle-uncheck.svg";
import "../../images/icons/plus.svg";
import "../../images/icons/microphone.svg";
import "../../images/icons/file.svg";
import "../../images/icons/camera.svg";
import "../../images/icons/eye-password-hide.svg";
import "../../images/icons/eye-password-show.svg";
import "../../images/icons/currency.svg";
import "../../images/icons/presence-available.svg";
import "../../images/icons/presence-away.svg";
import "../../images/icons/presence-dnd.svg";
import "../../images/icons/presence-offline.svg";
import "../../images/icons/presence-ooo.svg";
import "../../images/icons/fill-check.svg";